import { render, staticRenderFns } from "./faq_section.vue?vue&type=template&id=793bdc21&scoped=true&"
import script from "./faq_section.vue?vue&type=script&lang=js&"
export * from "./faq_section.vue?vue&type=script&lang=js&"
import style0 from "./faq_section.vue?vue&type=style&index=0&id=793bdc21&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "793bdc21",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/oeze/Documents/grupa/grupa-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('793bdc21')) {
      api.createRecord('793bdc21', component.options)
    } else {
      api.reload('793bdc21', component.options)
    }
    module.hot.accept("./faq_section.vue?vue&type=template&id=793bdc21&scoped=true&", function () {
      api.rerender('793bdc21', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/onboarding/client/designSprintFee/faq_section.vue"
export default component.exports